import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@coolblue-development/freddy';
import { DesktopSecondaryKevelBanners } from './DesktopSecondaryKevelBanners.js';
import { MobileSecondaryKevelBanners } from './MobileSecondaryKevelBanners.js';
export const SecondaryKevelBanners = ({ kevelAds }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Box, { hideFrom: "md", children: _jsx(MobileSecondaryKevelBanners, { kevelAds: kevelAds }) }), _jsx(Box, { hideUntil: "md", children: _jsx(DesktopSecondaryKevelBanners, { kevelAds: kevelAds }) })] }));
};
//# sourceMappingURL=SecondaryKevelBanners.js.map